import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';

import * as DisneyPlusAccountManagementActions from './../actions/disney-plus-account-management.actions';
import { IEntity } from '@proximus/entity-manager';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
  DisneyPlusWebTokenResource,
  TechnicalError,
} from '@dch/products-business-logic';
import { DisneyPlusAccountManagementService } from '../../services/disney-plus-account-management.service';

@Injectable({
  providedIn: 'root',
})
export class DisneyPlusAccountManagementEffects {
  getDisneyPlusToken$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(DisneyPlusAccountManagementActions.GET_DISNEY_PLUS_WEB_TOKEN),
      switchMap(
        (action: DisneyPlusAccountManagementActions.GetDisneyWebToken) =>
          this.disneyPlusAccountManagementService
            .getDisneyPlusToken(action.payload)
            .pipe(
              map(
                (entity: IEntity<DisneyPlusWebTokenResource>) =>
                  new DisneyPlusAccountManagementActions.GetDisneyWebTokenSuccess(
                    entity.value,
                  ),
              ),
              catchError((error: IEntity<TechnicalError>) =>
                of(
                  new DisneyPlusAccountManagementActions.GetDisneyPlusWebTokenFailed(
                    error.errorData as TechnicalError,
                  ),
                ),
              ),
            ),
      ),
    );
  });

  constructor(
    private actions$: Actions,
    private disneyPlusAccountManagementService: DisneyPlusAccountManagementService,
  ) {}
}
